module.exports = "/_next/static/images/Leadership-5cc354e7b0ff87b82922fbb077211cc3.webp";